import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiHint, TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'pxc-error-icon',
  templateUrl: './error-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'inline-flex',
  },
  imports: [TuiHint, TuiIcon],
})
export class ErrorIconComponent {
  readonly message = input.required<string>();
}
